/* Zakelijke pagina: alleen meetpunten.

   De pagina zelf werkt zonder JavaScript: alle inhoud staat server-side en
   het formulier is een gewoon Shopify-contactformulier. Wat hier staat is
   uitsluitend het doorgeven van doorkliks en verzendingen aan de datalayer,
   in hetzelfde patroon als de vloeren-PDP en de Bid & Buy-pagina. */
(function () {
  'use strict';

  function duw(gebeurtenis, gegevens) {
    window.dataLayer = window.dataLayer || [];
    var lading = { event: gebeurtenis, pageType: 'Page' };
    Object.keys(gegevens || {}).forEach(function (k) {
      lading[k] = gegevens[k];
    });
    window.dataLayer.push(lading);
  }

  document.addEventListener('click', function (e) {
    var strook = e.target.closest && e.target.closest('[data-solza-zakelijk-strook]');
    if (strook) {
      duw('solza_zakelijk_strook_klik', {
        zakelijk: { strook: strook.dataset.solzaZakelijkStrook || '' }
      });
    }
  });

  /* Bij het versturen gaat het gekozen type mee, want dat bepaalt welke
     samenwerking het wordt. Verder niets: naam, telefoonnummer en
     e-mailadres horen niet in een analytics-gebeurtenis. */
  var formulier = document.querySelector('.solza-pagina-formulier form');
  if (formulier) {
    formulier.addEventListener('submit', function () {
      var keuze = formulier.querySelector('select');
      duw('solza_zakelijk_aanmelding', {
        zakelijk: { type: keuze ? keuze.value : '' }
      });
    });
  }
})();
